import React, { useState, useEffect, useRef } from "react";

import { Link, useNavigate, useParams } from "react-router-dom";
import tutorsModal from "models/tutors.modal";
import DeviceUUID from "device-uuid";
import { helper } from "lib/helper";
import SubAdminModal from "models/user.modal";
import moment from "moment";
import levelModal from "models/level.modal";
import { Bar } from "react-chartjs-2";
import { Button, Col, Container, Input, Row, Table } from "reactstrap";
import ReportModel from "models/report.modal";

const Report = () => {

  const [datalist, setDatalist] = useState([]);
  const [currentData, setCurrentData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [activeButton, setActiveButton] = useState('students');
  const [chartData, setChartData] = useState(null);
  const itemsPerPage = 5;

  // New state for date filters
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  // Pagination logic
  const paginatedData = currentData.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

  // Chart data based on the active button
  const getChartData = (data) => {
    switch (activeButton) {
      case 'students':
        return {
          labels: data.map(person => person?.studentApi_parent?.auth_user?.first_name),
          datasets: [
            {
              label: 'Net Salary',
              data: data.map(person => person?.price_tutor),
              backgroundColor: 'rgba(75, 192, 192, 0.2)',
              borderColor: 'rgba(75, 192, 192, 1)',
              borderWidth: 1,
            },
            {
              label: 'Tuition Fee',
              data: data.map(person => person?.price_parent),
              backgroundColor: 'rgba(54, 162, 235, 0.2)',
              borderColor: 'rgba(54, 162, 235, 1)',
              borderWidth: 1,
            },
            {
              label: 'Margin',
              data: data.map(person => person?.margin),
              backgroundColor: 'rgba(255, 206, 86, 0.2)',
              borderColor: 'rgba(255, 206, 86, 1)',
              borderWidth: 1,
            }
          ]
        };
      case 'teachers':
        return {
          labels: data.map(person => person?.tutorApi_tutor?.auth_user?.first_name),
          datasets: [
            {
              label: 'Tuition Fee',
              data: data.map(person => person?.price_tutor),
              backgroundColor: 'rgba(54, 162, 235, 0.2)',
              borderColor: 'rgba(54, 162, 235, 1)',
              borderWidth: 1
            },
            {
              label: 'Net Salary',
              data: data.map(person => person?.price_parent),
              backgroundColor: 'rgba(75, 192, 192, 0.2)',
              borderColor: 'rgba(75, 192, 192, 1)',
              borderWidth: 1
            },
           
            {
              label: 'Margin',
              data: data.map(person => person?.margin),
              backgroundColor: 'rgba(255, 206, 86, 0.2)',
              borderColor: 'rgba(255, 206, 86, 1)',
              borderWidth: 1
            }
          ]
        };
      case 'parents':
        return {
          labels: data.map(person => person?.studentApi_parent?.auth_user?.first_name),
          datasets: [
            {
              label: 'Net Salary',
              data: data.map(person => person?.price_tutor),
              backgroundColor: 'rgba(75, 192, 192, 0.2)',
              borderColor: 'rgba(75, 192, 192, 1)',
              borderWidth: 1
            },
            {
              label: 'Tuition Fee',
              data: data.map(person => person?.price_parent),
              backgroundColor: 'rgba(54, 162, 235, 0.2)',
              borderColor: 'rgba(54, 162, 235, 1)',
              borderWidth: 1
            },
            {
              label: 'Margin',
              data: data.map(person => person?.margin),
              backgroundColor: 'rgba(255, 206, 86, 0.2)',
              borderColor: 'rgba(255, 206, 86, 1)',
              borderWidth: 1
            }
          ]
        };
      default:
        return null;
    }
  };

  // Fetch data from API
  const fetchData = async (fromDate, toDate) => {
    // Dummy data for income breakdown
    const dummyIncomeData = [
      {
        id: "1",
        studentApi_parent: {
          auth_user: {
            first_name: "Rajesh",
            last_name: "Kumar"
          }
        },
        tutorApi_tutor: {
          auth_user: {
            first_name: "Priya",
            last_name: "Sharma"
          }
        },
        price_tutor: 15000,
        price_parent: 20000,
        margin: 5000
      },
      {
        id: "2",
        studentApi_parent: {
          auth_user: {
            first_name: "Sunita",
            last_name: "Verma"
          }
        },
        tutorApi_tutor: {
          auth_user: {
            first_name: "Amit",
            last_name: "Singh"
          }
        },
        price_tutor: 12000,
        price_parent: 16000,
        margin: 4000
      },
      {
        id: "3",
        studentApi_parent: {
          auth_user: {
            first_name: "Meera",
            last_name: "Patel"
          }
        },
        tutorApi_tutor: {
          auth_user: {
            first_name: "Vikash",
            last_name: "Gupta"
          }
        },
        price_tutor: 18000,
        price_parent: 24000,
        margin: 6000
      },
      {
        id: "4",
        studentApi_parent: {
          auth_user: {
            first_name: "Deepak",
            last_name: "Joshi"
          }
        },
        tutorApi_tutor: {
          auth_user: {
            first_name: "Kavya",
            last_name: "Reddy"
          }
        },
        price_tutor: 14000,
        price_parent: 18000,
        margin: 4000
      },
      {
        id: "5",
        studentApi_parent: {
          auth_user: {
            first_name: "Pooja",
            last_name: "Bansal"
          }
        },
        tutorApi_tutor: {
          auth_user: {
            first_name: "Rohit",
            last_name: "Agarwal"
          }
        },
        price_tutor: 16000,
        price_parent: 21000,
        margin: 5000
      }
    ];
    
    setTimeout(() => {
      setDatalist(dummyIncomeData);
      setCurrentData(dummyIncomeData);
      setChartData(getChartData(dummyIncomeData));
    }, 1000);
  };

  // Fetch data when component mounts
  useEffect(() => {
    fetchData(startDate, endDate); // Fetch data on mount with empty dates
  }, []);

  // Update chart data when activeButton or currentData changes
  useEffect(() => {
    if (currentData.length > 0) {
      setChartData(getChartData(currentData));
    }
  }, [activeButton, currentData]);

  const handleFilter = async () => {
    // Simulate filtering with dummy data
    const filteredData = datalist.filter(item => {
      // Simple filter simulation - in real app would filter by date range
      return true; // Return all data for demo
    });
    
    setTimeout(() => {
      setCurrentData(filteredData);
      setChartData(getChartData(filteredData));
    }, 500);
  };

  const handlePrevious = () => {
    if (currentPage > 0) {
      setCurrentPage(prevPage => prevPage - 1);
    }
  };

  const handleNext = () => {
    if ((currentPage + 1) * itemsPerPage < currentData.length) {
      setCurrentPage(prevPage => prevPage + 1);
    }
  };

  const handleDataSwitch = (dataType) => {
    setActiveButton(dataType);
    setCurrentPage(0); // Reset pagination on data switch
  };

  const options = {
    scales: {
      y: { beginAtZero: true }
    }
  };

return (
  <Container className="pt-7">
  <div style={{ width: '90%', margin: '0 auto', padding: '20px', background: '#fff', borderRadius: '10px', boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)' }}>
    <Row className="pl-3 mb-2">
    <Col xs={12} md={6}>
  <h2>Income Breakdown</h2>
</Col>
<Col xs={12} md={6} className="d-flex align-items-center justify-content-md-end">
  <div className="d-flex align-items-center">
    <div className="d-flex align-items-center mr-2">
      <span className="mr-1">From</span>
      <Input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} placeholder="From" />
    </div>
    <div className="d-flex align-items-center mr-2">
      <span className="mr-1">To</span>
      <Input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} placeholder="To" />
    </div>
    <Button onClick={handleFilter}>Filter</Button>
  </div>
</Col>
    </Row>
    <hr className="mt-0 mb-0" />
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '20px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
        <button
          onClick={() => { handleDataSwitch('students'); }}
          style={{
            flex: 1,
            padding: '10px',
            border: '1px solid',
            borderColor: activeButton === 'students' ? 'transparent' : 'black',
            backgroundColor: activeButton === 'students' ? '#007bff' : 'white',
            color: activeButton === 'students' ? 'white' : 'black',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            margin: '5px'
          }}
        >
          Clients
        </button>
        <button
          onClick={() => { handleDataSwitch('teachers'); }}
          style={{
            flex: 1,
            padding: '10px',
            border: '1px solid',
            borderColor: activeButton === 'teachers' ? 'transparent' : 'black',
            backgroundColor: activeButton === 'teachers' ? '#007bff' : 'white',
            color: activeButton === 'teachers' ? 'white' : 'black',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            margin: '5px'
          }}
        >
          Tutors
        </button>
        <button
          onClick={() => { handleDataSwitch('parents'); }}
          style={{
            flex: 1,
            padding: '10px',
            border: '1px solid',
            borderColor: activeButton === 'parents' ? 'transparent' : 'black',
            backgroundColor: activeButton === 'parents' ? '#007bff' : 'white',
            color: activeButton === 'parents' ? 'white' : 'black',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            margin: '5px'
          }}
        >
          Category_Standard
        </button>
      </div>
      {chartData && <Bar data={chartData} options={options} />}
    </div>
    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px', marginBottom: '20px' }}>
      <Button onClick={handlePrevious} disabled={currentPage === 0} outline color="primary">Previous</Button>
      <Button onClick={handleNext} disabled={(currentPage + 1) * itemsPerPage >= currentData.length} outline color="primary">Next</Button>
    </div>
    <div style={{ overflowX: 'auto' }}>
      <Table className="align-items-center table-flush" responsive>
        <thead className="thead-light">
          <tr>
            <th style={{ border: '1px solid black', padding: '10px', textAlign: 'left' }}>Name</th>
            <th style={{ border: '1px solid black', padding: '10px', textAlign: 'left' }}>Tuition Fee</th>
            <th style={{ border: '1px solid black', padding: '10px', textAlign: 'left' }}>Net Salary</th>
            
            <th style={{ border: '1px solid black', padding: '10px', textAlign: 'left' }}>Margin</th>
          </tr>
        </thead>
        <tbody>
          {paginatedData.map((person, index) => (
            <tr key={index}>
              {activeButton === 'students' && (
                <>
                  <td style={{ border: '1px solid black', padding: '10px' }}>{person?.studentApi_parent?.auth_user?.first_name}</td>
                  <td style={{ border: '1px solid black', padding: '10px' }}>{person?.price_parent}</td>
                  <td style={{ border: '1px solid black', padding: '10px' }}>{person?.price_tutor}</td>
                  
                  <td style={{ border: '1px solid black', padding: '10px' }}>{person?.margin}</td>
                </>
              )}
              {activeButton === 'teachers' && (
                <>
                  <td style={{ border: '1px solid black', padding: '10px' }}>{person?.tutorApi_tutor?.auth_user?.first_name}</td>
                  <td style={{ border: '1px solid black', padding: '10px' }}>{person?.price_parent}</td>
                  <td style={{ border: '1px solid black', padding: '10px' }}>{person?.price_tutor}</td>
                  <td style={{ border: '1px solid black', padding: '10px' }}>{person?.margin}</td>
                </>
              )}
              {activeButton === 'parents' && (
                <>
                  <td style={{ border: '1px solid black', padding: '10px' }}>{person?.studentApi_parent?.auth_user?.first_name}</td>
                  <td style={{ border: '1px solid black', padding: '10px' }}>{person?.price_parent}</td>
                  <td style={{ border: '1px solid black', padding: '10px' }}>{person?.price_tutor}</td>
                  
                  <td style={{ border: '1px solid black', padding: '10px' }}>{person?.margin}</td>
                </>
              )}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  </div>
</Container>


);
};

  


export default Report;
